import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CurrencyProvider } from './context/CurrencyContext';
import Home from './pages/Home';
import Contact from './pages/Contact';
import PaymentStatus from './pages/PaymentStatus';
import PaymentCancel from './pages/PaymentCancel';
import TermsCondition from './pages/Legal/TermsCondition';
import PrivacyPolicy from './pages/Legal/PrivacyPolicy';
import CancellationRefunds from './pages/Legal/CancellationRefunds';
import ShippingDelivery from './pages/Legal/ShippingDelivery';

function App() {
  return (
    <CurrencyProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/payment-status" element={<PaymentStatus />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cancellation-and-refunds-policy" element={<CancellationRefunds />} />
          <Route path="/shipping-and-delivery-policy" element={<ShippingDelivery />} />
        </Routes>
      </Router>
    </CurrencyProvider>
  );
}

export default App;